import { useCallback as e, useRef as t, useState as n } from "react";
//#region src/hooks/useFreshMessageIds.ts
function r(r, i) {
	let [a] = n(() => {
		let e = new Set(r.map((e) => e.id)), t = 0;
		for (let e of r) {
			let n = e.created_at ? Date.parse(e.created_at) : 0;
			Number.isFinite(n) && n > t && (t = n);
		}
		return {
			ids: e,
			newest: t
		};
	}), o = t(/* @__PURE__ */ new Set());
	for (let e of r) {
		if (a.ids.has(e.id) || o.current.has(e.id) || !(i && e.sender_id === i) || e.pending) continue;
		let t = e.created_at ? Date.parse(e.created_at) : Date.now();
		(!Number.isFinite(t) || t >= a.newest) && o.current.add(e.id);
	}
	return e((e) => o.current.has(e), []);
}
//#endregion
export { r as useFreshMessageIds };
